import { Components } from '.generated/templates/Feature.Components.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import RoundImageCarouselItem, {
  RoundImageCarouselItemProps,
} from 'components/helpers/CarouselItem/RoundImageCarouselItem';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import Heading from 'components/helpers/Heading';
import { pushCarouselClickDataLayerObject } from 'lib/util/gtm-datalayer';
import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { classnames } from 'tailwindcss-classnames';

export type RoundImageCarouselProps = Sitecore.Override.ComponentBase &
  Components.General.Carousel.Fields.RoundImageCarousel;

const RoundImageCarousel = ({ fields }: RoundImageCarouselProps): JSX.Element => {
  const isFirstClickEvent = useRef(true);
  if (!fields) {
    return <MissingDataSource />;
  }

  const swiperControlsClasses = classnames('m-auto', 'flex', 'h-6', 'w-max', 'items-center');

  const carouselItems = fields.carouselItems.map((item) => {
    return {
      ...item,
    } as RoundImageCarouselItemProps;
  });

  let clickAction = '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleRealIndexChange = async (swiper: any) => {
    if (isFirstClickEvent.current && swiper.realIndex === 1) {
      isFirstClickEvent.current = false;
      return;
    }
    // eslint-disable-next-line no-promise-executor-return
    await new Promise((r) => setTimeout(r, 200));
    pushCarouselClickDataLayerObject(
      swiper.realIndex,
      clickAction,
      'round image carousel',
      carouselItems
    );
    clickAction = '';
  };
  const handlePrev = () => {
    clickAction = 'carousel - left click';
  };
  const handleNext = () => {
    clickAction = 'carousel - right click';
  };

  return (
    <section data-component="authorable/Heroes/RoundImageCarousel" className="round-img-carousel">
      <div className={classnames('my-10', 'md:my-16')}>
        <Heading
          headingText={fields?.heading}
          headingLevel="h2"
          headingSize="l"
          headingAlignment="center"
        />
        <div className={classnames('page-section')}>
          <Swiper
            loop
            slidesPerView={1.3}
            initialSlide={carouselItems.length > 1 ? 1 : 0}
            centeredSlides
            speed={300}
            spaceBetween={4}
            navigation={{
              prevEl: '.swiper-button-prev',
              nextEl: '.swiper-button-next',
            }}
            pagination={{
              clickable: true,
              el: '.swiper-pagination',
              bulletElement: 'button',
            }}
            breakpoints={{
              768: {
                slidesPerView: 3,
                spaceBetween: 0,
              },
            }}
            onRealIndexChange={handleRealIndexChange}
          >
            {carouselItems.map((carouselItem, index) => (
              <SwiperSlide key={carouselItem.id}>
                <RoundImageCarouselItem
                  {...carouselItem}
                  index={index}
                  carouselName={carouselItem.name}
                />
              </SwiperSlide>
            ))}
            {carouselItems.length > 1 && (
              <div slot="container-end">
                <div className={swiperControlsClasses}>
                  <button type="button" className="swiper-button-prev" onClick={handlePrev}>
                    prev
                  </button>
                  <div className="swiper-pagination" />
                  <button type="button" className="swiper-button-next" onClick={handleNext}>
                    next
                  </button>
                </div>
              </div>
            )}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default RoundImageCarousel;
